module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bubble_convergence-af82fbc1dbc61d9dcfd529ef11449c30.svg";